import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BlockType } from '../../../../../config/api/models/Block';
import { Tooltip } from '../../../../shared/components';
import { getFAIconByType } from '../../../helpers';
import AddBlockButtonTooltip from './AddBlockButtonTooltip';
import { ButtonWrapper } from './Atoms';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { FontAwesomeSpriteButton } from 'src/modules/shared/components/FontAwesomeLocal';
import theme from 'src/config/theme';

export type AddBlockButtonProps = {
  type: BlockType;
  onClick: () => void;
  viewBox?: string;
  FAicon?: SpriteIconsLight;
  tooltip?: string;
};

const AddBlockButton: FC<AddBlockButtonProps> = ({ type, onClick, viewBox, FAicon, tooltip }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={
        <AddBlockButtonTooltip
          title={tooltip ? tooltip : t(`trajectory.page.blocks.${type}.title`)}
          description={tooltip ? '' : t(`trajectory.page.blocks.${type}.description`)}
        />
      }
      placement="bottom"
    >
      <ButtonWrapper onClick={onClick}>
        <FontAwesomeSpriteButton
          icon={getFAIconByType(type)}
          iconSize="md"
          color={theme.palette.primary.main}
        />
      </ButtonWrapper>
    </Tooltip>
  );
};

export default AddBlockButton;
